import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle",
  "use": "icon-circle-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-circle\">\n    <title>时间轴</title>\n    <g id=\"icon-circle_pc主站-\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-circle_1-2区县级客户首页\" transform=\"translate(-1231.000000, -615.000000)\" stroke=\"#E5E5E5\" stroke-width=\"2\">\n            <g id=\"icon-circle_编组-21\" transform=\"translate(1231.000000, 614.000000)\">\n                <g id=\"icon-circle_编组-20\" transform=\"translate(0.000000, 1.000000)\">\n                    <circle id=\"icon-circle_时间轴\" cx=\"6\" cy=\"6\" r=\"5\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/circle.svg
// module id = 5gjf
// module chunks = 9